//internal
import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';
import { keywordFilteredPack, filterUndefined } from 'js/toolbar/filters';
//material ui
import Button from '@material-ui/core/Button';
import { styled } from '@material-ui/core/styles';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import copy from 'copy-to-clipboard';

//react
import React from 'react';

// const MyButtonPNG = styled(Button)({
//   position: 'relative',
//   opacity: 1,
//   fontSize: '14px',
//   letterSpacing: 0,
//   textTransform: 'uppercase',
//   fontWeight: 500,
//   margin: 0,
//   padding: '0px 16px',
//   userSelect: 'none',
//   lineHeight: '36px',
//   color: '#ffffff',
//   background: '#1e74b4'
// });
// const MyButtonSVG = styled(Button)({
//   position: 'relative',
//   opacity: 1,
//   fontSize: '14px',
//   letterSpacing: 0,
//   textTransform: 'uppercase',
//   fontWeight: 500,
//   margin: 0,
//   padding: '0px 16px',
//   userSelect: 'none',
//   lineHeight: '36px',
//   color: '#ffffff',
//   background: '#b62d2e'
// });

const basePath = window.location.href.split('#')[0];

let filteredPacks = [];
const downloadOptions = [
  { extension: '.png', text: 'PNG 16', color: '#3498DB ', size: 16 },
  { extension: '.png', text: 'PNG 32', color: '#3498DB ', size: 32 },
  { extension: '.png', text: 'PNG 64', color: '#3498DB ', size: 64 },
  { extension: '.png', text: 'PNG 256', color: '#3498DB ', size: 256 },
  { extension: '.svg', text: 'SVG 256', color: '#ff8533 ', size: 256 },
];

let init = function () {
  if (subCategoryStore.getState().currentIcon.path === undefined) {
    if (window.location.href.indexOf('?') > -1) {
      let keywords = window.location.href.split('?')[1].split('%20');

      const packs = subCategoryStore.getState().symbologyJson.packs;

      let startUpIcon = null;
      packs.forEach((subpacks) => {
        subpacks.subpacks.forEach((subpack) => {
          subpack.icons.forEach((icon) => {
            if (
              icon.keywords.length === keywords.length &&
              keywords.every((keyword) => icon.keywords.indexOf(keyword) > -1)
            ) {
              startUpIcon = icon;
            }
          });
        });
      });

      subCategoryActions.updateCurrentIcon(startUpIcon);

      let obj = {
        text: ' > ' + keywords.join(' '),
        link: '#/single?' + keywords.join('%20'),
      };

      subCategoryActions.appendToBreadCrumbs(obj);
    }
  }
};

export class SingleIconPage extends React.Component {
  constructor() {
    super();

    this.state = {
      copied: false,
      fileType: '',
      labelWidth: 113,
    };
    window.scrollTo(0, 0);
  }

  setFileType(fileType) {
    this.setState({
      fileType,
    });
  }

  updateURL = (path) => {
    const downloadOption = downloadOptions.find((option) => {
      return option.text === this.state.fileType;
    });
    return downloadOption
      ? path.slice(0, path.lastIndexOf('_')) +
          '_' +
          downloadOption.size +
          'x' +
          downloadOption.size +
          downloadOption.extension
      : '';
  };

  copyURL() {
    const state = subCategoryStore.getState();
    const baseUrl = state.symbologyJson.meta.s3_root_url;
    const iconPath = this.updateURL(state.currentIcon.path);
    const url = 'https:' + baseUrl + iconPath;
    copy(url);
    gtag('event', 'Single Icon Copied', {
      event_category: 'URL Copied',
      event_label: iconPath,
    });

    this.setState({
      copied: true,
    });
    setTimeout(() => {
      this.setState({
        copied: false,
      });
    }, 1500);
  }
  downloadIcon() {
    const state = subCategoryStore.getState();
    const iconPath = this.updateURL(state.currentIcon.path);
    gtag('event', 'Single Icon Download', {
      event_category: 'Download',
      event_label: iconPath,
    });
  }

  render() {
    console.log('SINGLEEE');
    debugger;
    init();

    let Keyword = (k) => {
      return (
        <span className='padding--small keywords'>
          {<a href={basePath + '#/subcat?' + k}>{k}</a>}
        </span>
      );
    };

    let image = () => {
      let icon = subCategoryStore.getState().currentIcon;
      let url =
        icon.path.slice(0, icon.path.lastIndexOf('_')) +
        icon.path.slice(icon.path.lastIndexOf('_'));

      let svgUrl = url.slice(0, url.length - 11) + '256x256.svg';

      return (
        <img
          src={
            subCategoryStore.getState().symbologyJson.meta.s3_root_url + svgUrl
          }
          height='256'
        />
      );
    };

    const { fileType, copied, labelWidth } = this.state;
    const state = subCategoryStore.getState();
    const baseUrl = state.symbologyJson.meta.s3_root_url;
    const iconPath = this.updateURL(state.currentIcon.path);
    const filename = iconPath.slice(
      iconPath.lastIndexOf('/') + 1,
      iconPath.length
    );
    const url = 'https:' + baseUrl + iconPath;
    return (
      <div className='single-icon-container flex single-page'>
        <div className='icon-container'>
          <p className='text-center hidden'>
            <b>Keywords:</b>
            {subCategoryStore
              .getState()
              .currentIcon.keywords.map(Keyword || [])}
          </p>
          <div className='image-container margin-auto flex'>{image()}</div>

          <p className='text-center'>
            {subCategoryStore.getState().currentIcon.description}
          </p>

          <div className='download-options flex'>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <FormControl variant='outlined' className='single-icon-file-type'>
                <InputLabel id='demo-simple-select-outlined-label'>
                  Select File Type
                </InputLabel>
                <Select
                  labelId='demo-simple-select-outlined-label'
                  id='demo-simple-select-outlined'
                  value={fileType}
                  onChange={(evt) => {
                    this.setFileType(evt.target.value);
                  }}
                  labelWidth={labelWidth}
                >
                  {downloadOptions.map((type) => {
                    return <MenuItem value={type.text}>{type.text}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button
                className='icon-button'
                disabled={fileType === ''}
                variant='contained'
                onClick={() => this.downloadIcon()}
              >
                {filename !== '' ? (
                  <a href={url} download={filename} target='_blank'>
                    Download
                  </a>
                ) : (
                  'Download'
                )}
              </Button>
              <Button
                className='icon-button'
                disabled={fileType === ''}
                variant='contained'
                onClick={() => {
                  this.copyURL();
                }}
              >
                {copied ? 'Copied' : 'Copy URL'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/single-icon/singleIcon.js